import type { AdminChatMessage } from '../hooks/useAdminAgentChat';
import { AdminMarkdown } from './AdminMarkdown';
import { CopyMessageButton } from './CopyMessageButton';

interface AdminAgentMessageProps {
  message: AdminChatMessage;
  /** The assistant is still writing this message. */
  streaming?: boolean;
}

export const AdminAgentMessage: React.FC<AdminAgentMessageProps> = ({ message, streaming }) => {
  const isUser = message.role === 'user';

  return (
    <div className={`group flex items-start gap-1 ${isUser ? 'flex-row-reverse' : ''}`}>
      <div
        className={`min-w-0 max-w-[88%] overflow-hidden rounded-lg px-3.5 py-2 ${
          isUser
            ? 'bg-blue-500 text-white dark:bg-blue-600'
            : 'bg-slate-100 text-slate-900 dark:bg-slate-700 dark:text-slate-100'
        }`}
      >
        {isUser ? (
          <div className="whitespace-pre-wrap break-words text-sm leading-relaxed [overflow-wrap:anywhere]">
            {message.text}
          </div>
        ) : (
          <>
            <AdminMarkdown text={message.text} className="text-sm leading-relaxed" />
            {streaming && (
              <span className="ml-0.5 inline-block h-4 w-1.5 animate-pulse rounded-sm bg-slate-400 align-middle" />
            )}
          </>
        )}
      </div>
      {!streaming && <CopyMessageButton text={message.text} />}
    </div>
  );
};
